import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { IconX } from '@tabler/icons-react'
import ImageBrowse from "../../../../Common/Image/ImageBrowse";

const Story = forwardRef(
  function Story(props, ref) {
    const [title, setTitle] = useState("");
    const [storyDate, setStoryDate] = useState("");
    const [description, setDescription] = useState("");
    const [imageKey, setImageKey] = useState("");
    const [isOpen, setIsOpen] = useState("");
    const [errors, setErrors] = useState({});
    const imageRef = useRef();

    useEffect(() => {
      if (props.data) {
        setTitle(props.data.title);
        setIsOpen(props.data.show);
        setDescription(props.data.description);
        setStoryDate(props.data.date);
        setImageKey(props.data.imageKey);

        imageRef?.current?.setThumbnail(props.data.image && props.data.image != "" ? props.data.image : null);
        imageRef?.current?.setFileContent(props.data.imageFile);
      }
    }, [props.data])

    useEffect(() => {
      setIsOpen(props.data.show);
    }, [props.data.show]);

    const validate = () => {
      const errors = {};

      if (!title || (title && title.trim() == "")) {
        errors.title = "Title is required";
      }

      if (!storyDate || (storyDate && storyDate.trim() == "")) {
        errors.storyDate = "Story date is required";
      }

      setErrors(errors);
      return Object.keys(errors).length === 0;
    }

    const getData = () => {
      return {
        title: title,
        date: storyDate,
        description: description,
        image: imageRef?.current?.getThumbnail() ?? null,
        imageFile: imageRef?.current?.getImageFile() ?? null,
        imageKey: imageKey
      }
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));

    return (
      <div className="card accordion-item ">
        <h2 className="accordion-header">
          <button type="button"
            onClick={() => props.showHideStory(props.index)}
            className={`accordion-button ${isOpen ? "" : "collapsed"}`}>
            {title}
          </button>
        </h2>

        <div className={`accordion-collapse ${isOpen ? "show" : "collapse"}`}>
          <div className="accordion-body mt-3">
            <form>
              <div className="row">

                <div className="col-md-6 mt-2">
                  <label className="form-label required">
                    Title
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.title ? "is-invalid" : ""}`}
                    placeholder="Enter title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                  {errors.title && (
                    <div className="invalid-feedback">
                      {errors.title}
                    </div>
                  )}
                </div>
                <div className="col-md-6 mt-2">
                  <label className="form-label required">
                    Story Date
                  </label>
                  <input
                    type="date"
                    className={`form-control ${errors.storyDate ? "is-invalid" : ""}`}
                    placeholder="Select story date"
                    data-date-format="dd-mm-yyyy"
                    value={storyDate}
                    onChange={(e) => setStoryDate(e.target.value)}
                  />
                  {errors.storyDate && (
                    <div className="invalid-feedback">
                      {errors.storyDate}
                    </div>
                  )}
                </div>
                <div className="col-md-6 mt-2">
                  <label className="form-label">
                    Description
                  </label>
                  <textarea
                    style={{ height: "245px", resize: "none" }}
                    className={`form-control ${errors.description ? "is-invalid" : ""}`}
                    placeholder="Enter description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}></textarea>
                </div>
                <div className="col-md-6 mt-2">
                  <label className="form-label" htmlFor="image">
                    Image <small className="text-gray">(Max Allowable File Size: 1MB,Image Dimensions: 590px x 300px)</small>
                  </label>
                  <ImageBrowse elementId={"storyImage-" + props.index} ref={imageRef} imageType="story"
                    imageKey={imageKey} setImageKey={setImageKey} imageDelete={props.imageDelete} />
                </div>
              </div>
              <div className="col-12 mt-3">
                <button type="button" className="btn btn-label-danger"
                  onClick={() => props.deleteStory(props.index)}>
                  <IconX className="me-1" size={16} />
                  <span className="align-middle">Delete</span>
                </button>
              </div>
            </form>
          </div>
        </div >
      </div >
    )
  });

export default Story;
